import React, { useState } from "react";
import "./FloorplansModal.css"; 
import FloorplanIcon from "../Assets/Images/floorplans.png";

const FloorplansModal = ({ floorplans }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);

  // Don't render anything if no floorplans exist
  if (!floorplans || floorplans.length === 0) {
    return null;
  }

  return (
    <div className="container">
      <div className="floorplans-grid">
        {floorplans.map((floorplan, index) => (
          <div key={index} className="floorplan-item">
            <button
              className="view-button"
              onClick={() => setSelectedImage(floorplan.url)}
            >
              <img
                src={FloorplanIcon}
                alt="Floorplan Icon"
                className="button-icon"
              />
             Floorplans
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-button"
              onClick={() => setSelectedImage(null)}
            >
              &times;
            </button>
            <img
              src={selectedImage}
              alt="Floorplan Enlarged"
              className={`modal-image ${isZoomed ? "zoomed" : ""}`}
              onClick={() => setIsZoomed(!isZoomed)} // Toggle zoom on click
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FloorplansModal;
